import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  showRetryButton?: boolean;
  icon?: string;
  className?: string;
}

const ErrorState = ({
  title,
  description,
  onRetry,
  showRetryButton = true,
  icon = 'ri-error-warning-line',
  className = '',
}: ErrorStateProps) => {
  const { t } = useTranslation();

  return (
    <div className={`bg-white rounded-lg shadow-sm p-12 text-center ${className}`}>
      <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-red-100 rounded-full">
        <i className={`${icon} text-5xl text-red-500`}></i>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {title || t('common.error.load_failed', { defaultValue: 'Failed to load data' })}
      </h3>
      <p className="text-gray-600 mb-6 max-w-md mx-auto">
        {description || t('common.error.try_again_hint', { defaultValue: 'Please try again later or contact support if the problem persists.' })}
      </p>
      {showRetryButton && onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line mr-2"></i>
          {t('common.actions.retry', { defaultValue: 'Retry' })}
        </button>
      )}
    </div>
  );
};

export default ErrorState;
